import {configureStore} from "@reduxjs/toolkit"
import participantOutcomeReducer  from "../features/pacticipantOutcomeSlice"
export const store  = configureStore({
  reducer:{
    participantOutcome: participantOutcomeReducer
  }
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch